export default __webpack_public_path__ + "static/media/image.9f0f0da1.svg";